module.exports = __webpack_public_path__ + "e9db8f1247701943213932a60f7744f1.png";